import { render, staticRenderFns } from "./PanelBoardShow.vue?vue&type=template&id=719d7f36&"
import script from "./PanelBoardShow.vue?vue&type=script&lang=js&"
export * from "./PanelBoardShow.vue?vue&type=script&lang=js&"
import style0 from "./PanelBoardShow.vue?vue&type=style&index=0&id=719d7f36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports